export enum LinkDirectionEnum {
  BOTH = "BOTH",
  TO = "TO",
  FROM = "FROM",
}
